export default __webpack_public_path__ + "static/media/icons-company-info.4eb1a4ad.svg";